import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import SelectEvent from '../controls/SelectEvent.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';
import '../../../resources/css/relatorio.css';

class VendasPorPagamento extends React.Component {

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.RELATORIO_VENDAS_POR_PAGAMENTO)
            return null;

        const token = this.props.token;
        const eventId = this.props.participants.selectedEvent ? this.props.participants.selectedEvent.id : null;

        const datatablesColumns = [
            { data: "payment", title: "Forma de Pagamento", render: $.datatable.renders.text() },
            { data: "count", title: "Qtd Carrinhos", render: $.datatable.renders.number(".", ",", 0) },
            { data: "total", title: "Total (R$)", render: $.datatable.renders.money(".", ",", 2) },
            { data: "percent", title: "Percentual (%)", render: $.datatable.renders.number(".", ",", 2) },
        ];

        let urlBase = '/api/reports/vendas/por_pagamentos';
        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: `${urlBase}?${$.param(_.pickBy({eventId}, _.identity))}`,
        });

        const buttons = [
            {
                extend: 'csv',
                text: 'download',
                fieldSeparator: ';',
                filename: 'VendasPorPagamento',
            },
        ];

        const domClassName = 'report-vendas-por-pagamento-datatables';

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Relatório de Vendas por forma pagamento</h2>
                    </div>
                </div>

                <SelectEvent {...this.props}/>

                <Datatable DomClassName={domClassName}
                           title={null}
                           subTitle={null}
                           responsive={true}
                           pageLength={100}
                           buttons={buttons}
                           editorCreateVisible={false}
                           editorEditVisible={false}
                           editorRemoveVisible={false}
                           datatablesColumns={datatablesColumns}
                           datatablesSelect={callbacks.select.bind(callbacks)}
                />
            </div>
        );
    }
}

export default VendasPorPagamento;



// WEBPACK FOOTER //
// src/views/pages/RelatorioVendasPorPagamento.jsx